<template>
	<div class="panel">
		<div class="panel-body">
			<div class="row">
				<div class="col-sm-12">
					<button @click="fh()" type="button" class="btn btn-primary btn-sm pull-right" style="margin-right: 3px;"><i class="fa fa-undo"
						 aria-hidden="true"></i>返回</button>
					<button @click="choosefdy()" type="button" class="btn btn-primary btn-sm"><i class="" aria-hidden="true"></i>选择班主任</button>
				</div>
			</div>
			<div class="row">
				<div class="col-sm-12" style="padding-top: 10px">
					<BootstrapTable style="font-size: 14px;" ref="table" v-once :columns="columns"
					 :options="{
										classes:'table table-hover',
                                    	undefinedText:'',
                                        showColumns: false,
                                        sidePagination:'server',
                                        pagination:true,
                                        pageNumber:1,
                                        pageSize:10,
                                        pageList:[10,50,100,500],
                                        paginationPreText:'上一页',
                                        paginationNextText:'下一页',
                                        showExtendedPagination:true,
                                        paginationLoop:false
                                    }"
					 @onPostBody="vueFormatterPostBody" @onPageChange="pageChange" @onClickRow="clickRow" />
				</div>
			</div>
		</div>
		<BjFdyXz ref="BjFdyXz"></BjFdyXz>
	</div>
</template>
<script>
	import tableMixin from '@/mixins/table.js';
	import BjFdyXz from './BjFdyXz.vue';
	export default {
		mixins: [tableMixin],
		name: "BjFdyXqList",
		components: {
			BjFdyXz
		},
		data: function() {
			return {
				query: {
					bjId: this.$route.query.bjId
				},
				columns: [{
						title: '序号',
						field: 'id',
						align: 'center',
						formatter: (value, row, index) => {
							var options = this.$refs.table.getOptions();
							return options.pageSize * (options.pageNumber - 1) + index + 1;
						}
					},
					{
						field: 'xm',
						title: '姓名',

					},
					{
						field: 'sfzh',
						title: '身份证号'
					},
					{
						field: 'actions',
						title: '操作',
						align: 'center',
						formatter: (value, row) => {
							return this.vueFormatter({
								template: '<div class="operation_column">' +
									'<a @click="del(row)">删除</a></div>',
								data: {
									row
								},
								methods: {
									edit: this.edit,
									del: this.del,
								}
							})
						}
					}
				]
			}
		},
		mounted() {
			this.query = Object.assign(this.query, {
				current: 1,
				size: 10
			}, this.$route.query);
			this.load();
		},
		beforeRouteUpdate(to, from, next) {
			this.query = Object.assign(this.query, {
				current: 1,
				size: 10
			}, to.query);
			this.load();
			next();
		},
		created: function() {
			this.$store.commit('setBreadcrumb', [{
				name: '系统管理'
			}, {
				name: '机构管理'
			}, {
				name: '班级管理'
			}, {
				name: '班主任管理'
			}]);
		},
		methods: {
			fh: function() {
				this.$router.push({
					name: 'BjList'
				})
			},
			addfdy: function() {
				this.$refs.BjFdyAdd.open({
					bjId: this.query.bjId
				});
			},
			choosefdy: function() {
				this.$refs.BjFdyXz.open({
					bjId: this.query.bjId
				});
			},
			//修改
			edit: function(row) {
				this.$refs.BjFdyEdit.open({
					id: row.id
				});
			},
			//删除
			del: function(row) {
				this.$confirm('确定进行此操作吗？',()=>{
					this.$http.post('/htgl/sys/bj/scfdy', {
						bjId: this.query.bjId,
						fdyId: row.id
					}).then(res => {
						if (res.data == true) {
							this.$success('操作成功',()=>{
								this.load();
							});
						}
					});
				});
			},
			//根据查询条件进行检索
			search: function() {
				//将数据表格的页码以及每一页展示的数据重置为1，10
				let query = Object.assign(this.query, {
					current: 1,
					size: 10
				}, {
					_t: new Date().getTime()
				});
				this.$router.push({
					name: this.$route.name,
					query: query
				});
			},
			load: function(pageNumber, pageSize) {
				this.query.current = pageNumber || this.query.current;
				this.query.size = pageSize || this.query.size;
				this.$http.post('/htgl/sys/bj/fdyxqlb', this.query).then(res => {
					let data = res.data;
					//封装返回值
					let result = {
						total: data.total,
						rows: data.records
					};
					//table加载返回的数据
					this.$refs.table.load(result);
					this.$refs.table.refreshOptions({
						pageNumber: parseInt(this.query.current),
						pageSize: parseInt(this.query.size)
					});
				});
			},
			pageChange: function(pageNumber, pageSize) {
				let query = Object.assign(this.query, {
					current: pageNumber,
					size: pageSize
				}, {
					_t: new Date().getTime()
				});
				this.$router.push({
					name: this.$route.name,
					query: query
				});
			}

		}

	}
</script>
<style scoped>
	.xzGg {
		padding-right: 26px;
	}
</style>
